import styled from 'styled-components'
import { CommonStyles } from './common/common'
import { getCheckbox as getMustoCheckbox } from './musto/style'
import { getCheckbox as getTotemeCheckbox } from './toteme/style'
import { getCheckbox as getBjornborgCheckbox } from './bjornborg/style'
import { getCheckbox as getAsketCheckbox } from './asket/style'
import { getCheckbox as getRoyalCheckbox } from './royal_design/style'

export const CheckboxStyle = styled.label`
	${CommonStyles}

	${(props) => getRoyalCheckbox(props)};

	${(props) => getBjornborgCheckbox(props)};

	${(props) => getAsketCheckbox(props)};

	${(props) => getTotemeCheckbox(props)};

	${(props) => getMustoCheckbox(props)};
`
